import React, { useEffect, useState } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { useFormik } from 'formik';
import { FaEnvelope, FaEye, FaEyeSlash } from 'react-icons/fa';
import InputField from '../FormFields/InputField';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import ApiService from '../../helper/apiService';
import { APIS } from '../../apis';
import { getUserName } from '../../helper/access';

const CreateRoom = () => {
    const [errorMsg, setErrorMesssage] = useState("");
    const [link, setLink] = useState("");
    const [uname, setUname] = useState(getUserName())

    const formik = useFormik({
        initialValues: {
            name: uname || '',
            roomName: '',
            participants: ''
        },
        validationSchema: Yup.object({
            name: Yup.string()
                .required('Name is Required'),
            roomName: Yup.string().required('Room name is required'),
            participants: Yup.string().required('Participants are required'),
        }),
        onSubmit: async (values, { setSubmitting }) => {
            let participants = values?.participants
                ?.split(',')
                .map(participant => participant.trim())
                ?? [];
            participants.push(getUserName())

            let payload = {
                roomId: values?.roomName,
                userName: values?.name,
                meetingType: "instant",
                participants: participants
            }
            let room_resp = await createRoomAPI(payload);
            if (room_resp?.room_unique_id) {
                formik.resetForm();
                setErrorMesssage("")
                setLink(room_resp?.room_unique_id)
            } else {
                setLink("")
                setErrorMesssage("Something went wrong")
            }
            setSubmitting(false);
        }
    });

    const createRoomAPI = async (payload) => {
        const response = await ApiService.post(`${APIS.CREATE_ROOM}`, payload);
        if (response?.data) {
            return response?.data
        } else {
            return null
        }
    }

    return (
        <div className="bodyTabWrap">
            <div className="pt-5 tabWrap">
                <div className="mt-5 formWrap">
                    <Row>
                        <h3>Create Room</h3>
                        <Col md={12}>
                            <form onSubmit={formik.handleSubmit}>
                                {/* Room Name */}
                                <div className="inputWrap">
                                    <label>Room Name</label>
                                    <div className="input-group">
                                        <InputField
                                            name="roomName"
                                            placeholder="Enter room name"
                                            type="text"
                                            value={formik.values.roomName}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.errors.roomName}
                                            touched={formik.touched.roomName}
                                        />
                                    </div>
                                </div>

                                {/* Your Name */}
                                <div className="inputWrap">
                                    <label>Your Name</label>
                                    <div className="input-group">
                                        <InputField
                                            name="name"
                                            placeholder="Enter your name"
                                            type="text"
                                            value={formik.values.name}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.errors.name}
                                            touched={formik.touched.name}
                                        />
                                    </div>
                                </div>

                                {/* Participants */}
                                <div className="inputWrap">
                                    <label>Participants</label>
                                    <div className="input-group">
                                        <InputField
                                            name="participants"
                                            placeholder="Enter participant names"
                                            type="text"
                                            value={formik.values.participants}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.errors.participants}
                                            touched={formik.touched.participants}
                                        />
                                    </div>
                                </div>

                                {/* Error Message */}
                                {errorMsg && (
                                    <div className="errorMessage">
                                        {errorMsg}
                                    </div>
                                )}

                                {/* Link Display */}
                                {link && (
                                    <div className="linkWrap">
                                        <p>Use the below link for call</p>
                                        <span>{link}</span>
                                        <button
                                            type="button"
                                            onClick={(e) => navigator.clipboard.writeText(link)}
                                        >
                                            Copy
                                        </button>
                                    </div>
                                )}

                                {/* Buttons */}
                                <div className="buttonWrap" style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                                    <Button variant="primary" type="submit">
                                        {formik.isSubmitting ? "Creating room ..." :"Create"}
                                    </Button>
                                    <Button
                                        variant="secondary"
                                        type="button"
                                        onClick={() => {
                                            formik.resetForm();
                                            setLink("");
                                            setErrorMesssage("");
                                        }}
                                    >
                                        Clear
                                    </Button>
                                </div>
                            </form>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>

    )
}

export default CreateRoom;